import React from 'react';
import { hot } from 'react-hot-loader';
import s from './File.scss';

const FileBlock = ({ content }) => (
	content.map((f) => {
		if (/\.pdf$/.test(f.attrs.href)) {
			return (
				<object className={s.file} type="application/pdf" data={f.attrs.href}>
					{ f.attrs.rawText }
				</object>
			);
		}
		return null;
	})
);

export default hot(module)(FileBlock);
